import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOrganization } from 'src/api/organizations-queries';

export function OrganizationalUnitsTableV2() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { organizationId } = useParams();

  const { data, isLoading } = useGetOrganization(organizationId);

  const organizationalUnits = useMemo(() => data?.organizationalUnits ?? [], [data]);

  const headers = [
    { label: 'Name', key: 'name' },
    { label: 'Researchers', key: 'researchers' },
    { label: 'Studies', key: 'studies' },
    { label: 'Data sets', key: 'dataSets' },
  ];

  const transformedData = useMemo(
    () =>
      organizationalUnits
        .filter((organizationalUnit) =>
          organizationalUnit.name.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((organizationalUnit) => ({
          id: organizationalUnit.organizationId,
          name: organizationalUnit.name,
          researchers: organizationalUnit.numResearchers,
          studies: organizationalUnit.numStudies,
          dataSets: organizationalUnit.numDataSources,
        })) ?? [],
    [organizationalUnits, searchTerm],
  );

  return (
    <section className="flex flex-col w-full mt-12 border border-stroke-on-dark-subdued rounded-lg bg-background-dark-subdued px-4 py-6">
      <TableV2
        headers={headers}
        data={transformedData}
        searchPlaceholder="Search by name"
        onSearch={(t) => setSearchTerm(t)}
        isLoading={isLoading}
      />
    </section>
  );
}
